import { Text as ChakraText } from '@chakra-ui/react';

import type { ComponentProps, JSX } from 'react';

export function Text(props: ComponentProps<'p'>): JSX.Element {
  return <ChakraText color='white' {...props} />;
}
